export const isAuthenticated = user => !!user;

export const hasPermission = (user, permissions) =>
permissions.some(permission => user?._role?.rolePermission?.find((perm)=>perm?._permission?.name === permission));

export const hasRole = (user, roles) =>roles.some(role => user?._role?.code === role);